import React from "react";

import "./css/page-not-found.scss";

export default function PageNotFound() {
  return (
    <div className="page-not-found-section">
      <div className="bg-image"></div>
      <h2 className="bg-text">404</h2>
      <h1>Page Not Found</h1>
      <p>Please navigate back!!!</p>
    </div>
  );
}
